export const SUBMIT = "submit";
export const PRIMARY = "primary";
